module.exports = __webpack_public_path__ + "static/assets/1789fe52606d80dbfc5f1d787c9b8544.jpg";